<template>
  <nuxt-link
    :to="to"
    class="inline-flex items-center px-8 py-3 text-base font-medium text-white bg-primary rounded-xl hover:bg-primary/90 transition-all shadow-md group"
  >
    {{ text }}
    <Icon
      name="heroicons:arrow-right"
      class="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
    />
  </nuxt-link>
</template>

<script setup lang="ts">
defineProps<{
  to: string;
  text: string;
}>();
</script>
